import React, { memo, useContext } from 'react';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import './product-image.scss';

const styles = bemGenerator('pj-ui-product-image');

type ProductImageProps = {
  fallback?: string;
  src: string;
  name?: string | null;
  className?: string;
};

const ProductImage = ({
  fallback,
  src,
  name,
  className,
}: ProductImageProps) => {
  const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

  const fallbackImage =
    fallback && !/^https?:\/\//.test(fallback)
      ? market.cdn + fallback
      : fallback;

  const productImage =
    src || fallbackImage || `${market.cdn}/product/standard/280/0.jpg`;

  const productImageClass =
    styles.block.withModifier({
      'custom-fallback': !src && fallback,
    }) + (className ? ` ${className}` : '');

  return (
    <img src={productImage} alt={name || ''} className={productImageClass} />
  );
};

export default memo(ProductImage);
